<template>
    <a
        class="event-card base-card"
        :href="post.link"
        :target="linkTarget"
        :class="{ 'base-card--show': visible, 'event-card--new': isNew, 'event-card--download': allowDownload }"
    >
        <figure
            class="event-card__figure base-card__figure"
            :data-new-label="labelNew"
            :class="showBackgroundImage ? 'event-card__figure--has-image' : ''"
        >
            <template v-if="showBackgroundImage === 'yes'">
                <img
                    v-if="imageSrc"
                    class="base-card__image"
                    :src="imageSrc"
                    :srcset="imageSrcSet"
                    :sizes="sizes"
                >
                <img
                    v-else
                    class="base-card__image"
                    src="/wp-content/plugins/dbec-events/assets/images/event-background.jpg"
                    alt="Blurred photo of a train"
                >
            </template>

            <svg class="event-card__icon-calendar">
                <use xlink:href="#icon-calendar" />
            </svg>

            <div class="event-card__summary">
                <div
                    class="event-card__summary-headline event-card__summary-headline--small"
                >
                    <h2>{{ eventDateHeadline }}</h2>
                </div>

                <div
                    v-if="eventLocation"
                    class="event-card__summary-location"
                >
                    <svg class="event-card__summary-location-icon">
                        <use xlink:href="#icon-map-pin" />
                    </svg>
                    <span>{{ eventLocation }}</span>
                </div>

                <div
                    v-if="post.title"
                    class="event-card__summary-title"
                    :title="post.title.rendered || post.title"
                >
                    <h3 v-html="post.title.rendered || post.title"></h3>
                </div>
            </div>
        </figure>

        <div>
            <h2
                v-if="title"
                class="base-card__title"
                v-html="title"
            />

            <div
                v-if="publishDate"
                class="base-card__date"
            >
                {{ publishDate }}
            </div>


            <div
                v-if="post.excerpt"
                class="base-card__copy"
                v-html="post.excerpt.rendered"
            />
        </div>

        <ICSDownloadButton
            v-if="allowDownload"
            class="event-card__download"
            :event-url="post.link"
        />
    </a>
</template>

<script>
import ICSDownloadButton from './ICSDownloadButton.vue'
import { getSizesStringByColumns } from '@bahn-wordpress/common/src/js/admin/utils/source-set'
import { formatDate, formatTime } from '@bahn-wordpress/common/src/js/utils/data-formatter'

const DELAY_ANIMATION_WORD = 150

export default {
    name: 'CardPostEvent',

    components: {
        ICSDownloadButton,
    },

    props: {
        index: {
            type: Number,
            default: 0,
        },
        showBackgroundImage: {
            type: String,
            default: 'no',
        },
        labelNew: {
            type: String,
            default: 'New',
        },
        post: {
            type: Object,
            default(){
                return {}
            },
        },
    },

    data(){
        return {
            visible: false,
            linkTarget: '_self',
        }
    },

    computed: {

        eventDateHeadline(){
            const isSameDate = formatDate(this.eventStartDate) === formatDate(this.eventEndDate)
            const endDateFormatted = formatDate(this.eventEndDate, { month: '2-digit', day: '2-digit', year: 'numeric' })

            if (isSameDate) return `${endDateFormatted}`

            const startDateFormatted = formatDate(this.eventStartDate, { month: '2-digit', day: '2-digit' })

            return this.post.date
                ? `${startDateFormatted} - ${endDateFormatted}`
                : null
        },
        image(){
            return this.post.dbec_featured_media || {}
        },
        imageSrc(){
            return this.image.source_url
        },
        imageSrcSet(){
            return this.image.source_set
        },
        imageReference(){
            return this.image.caption
        },
        eventStartDate(){
            return new Date(`${this.post.meta.date_start || 0} ${this.post.meta.time_start}`)
        },
        eventEndDate(){
            return new Date(`${this.post.meta.date_end || 0} ${this.post.meta.time_end}`)
        },
        eventLocation(){
            return this.post.meta.location
        },
        sizes(){
            return getSizesStringByColumns({ small: 6, medium: 3, large: 2 })
        },
        isNew(){
            return this.post.meta.is_new === '1'

        },
        allowDownload(){
            return this.post.meta.allow_download === '1'
        },
        title(){
            return this.post.meta.title || this.post.title.rendered || this.post.title
        },
        publishDate(){
            if (this.post.date) {
                const english = document.documentElement.lang.startsWith('en')
                const date = new Date(this.post.date)
                const day = this.addLeadingZero(date.getDate())
                const month = this.addLeadingZero(date.getMonth() + 1)
                const year = date.getFullYear()

                return english
                    ? `${month}-${day}-${year}`
                    : `${day}.${month}.${year}`
            }
            return null
        },
    },

    mounted(){
        this.initCard()
    },

    methods: {
        initCard(){
            const timeoutMilliseconds = this.index * DELAY_ANIMATION_WORD //  + INITIAL_DELAY_ANIMATION_WORDS

            setTimeout(() => {
                this.visible = true
            }, timeoutMilliseconds)
        },
        formatTime,
        addLeadingZero(number){
            let numberAsString = String(number)
            if (numberAsString.length === 1) {
                numberAsString = `0${numberAsString}`
            }
            return numberAsString
        },
    },
}
</script>
